import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

// Curated themes only (no picker). Same layout/density/components across all.
// Night is parked for now (CSS block kept dormant in index.css for a future
// warm-dusk revisit) — adding it back later is one entry here + its CSS block.
export const THEME_OPTIONS = [
  { id: "daylight", label: "Daylight", desc: "Soft, warm and calm", bar: "#EDF0EC" },
  { id: "clear", label: "Clear", desc: "Crisp and bright", bar: "#F3F6F5" },
];

const STORAGE_KEY = "heldall_theme";
const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

const isValidTheme = (id) => THEME_OPTIONS.some((t) => t.id === id);

function applyTheme(id) {
  const t = THEME_OPTIONS.find((x) => x.id === id) || THEME_OPTIONS[0];
  document.documentElement.setAttribute("data-theme", t.id);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", t.bar);
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return isValidTheme(stored) ? stored : "daylight";  // parked/unknown themes fall back
    } catch (_) { return "daylight"; }
  });

  useEffect(() => { applyTheme(theme); }, [theme]);

  const setTheme = useCallback((id) => {
    const next = isValidTheme(id) ? id : "daylight";
    setThemeState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch (_) {}
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEME_OPTIONS }}>
      {children}
    </ThemeContext.Provider>
  );
}
